<template>
	<div class="container">
		<section class="mobile_cs">
			<div class="sub_content1 d_flex justify_center align_items_center">
				<h2 class="title">
					{{ $t('cs.title') }}
				</h2>
			</div>
		</section>
		<div class="content cs">
			<p class="title">{{ $t('cs.faq') }}</p>
			<div class="faq faq_border_top">
				<div v-if="faqList.length > 0">
					<accordion v-for="item in faqList" :key="item.seq" class="faq">
						<accordion-item>
							<template v-slot:accordion-trigger>
								<p class="question">{{ item.title }}</p>
								<span class="accordion_trigger_icon"></span>
							</template>

							<template v-slot:accordion-content>
								<p class="answer" v-html="item.content"></p>
							</template>
						</accordion-item>
					</accordion>
					<pagination
						:totalCount="pageNavigation.total_count"
						:totalPage="pageNavigation.total_page"
						:curPage="pageNavigation.cur_page"
						:point="pageNavigation.point"
						:firstPage="pageNavigation.first_page"
						:lastPage="pageNavigation.last_page"
						@change="pageChangeHandler"
					></pagination>
				</div>
				<div class="notice_no" v-else>
					<p>{{ $t('cs.inquiry.no_content') }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Accordion from '@/components/Layout/Accordion';
import AccordionItem from '@/components/Layout/AccordionItem';
import pagination from '@/components/Pagination';
import { fetchFaqList } from '@/api/cs';
import { commonError } from '@/common/dialog';
export default {
	name: 'Faq.m',
	components: { Accordion, AccordionItem, pagination },
	data() {
		return {
			faqList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadFaqList();
		},
		async loadFaqList() {
			const params = {
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchFaqList(params).catch(
				commonError,
			);
			this.faqList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadNoticeList();
		},
	},
};
</script>

<style scoped>
.m_faq .container {
	margin-bottom: 0;
}
section.mobile_cs .title {
	font-size: 30px;
	line-height: 1.2;
}
.mobile_cs .sub_content1 {
	width: 100%;
	min-height: 250px;
	margin: 0 auto;
	color: #fff;
	background-size: cover;
	background: #000 url('~@/assets/images/sub/cs.png') no-repeat 43% 0;
}
.content.cs {
	width: 100%;
	padding: 30px 16px;
	min-height: 300px;
}
.content.cs .title {
	padding-bottom: 25px;
	font-size: 24px;
	line-height: 1.2;
	font-weight: bold;
	text-align: center;
}
.faq .answer {
	display: block;
	padding: 12px 16px;
}
.notice_no {
	border-bottom: 1px solid #ddd;
}
.notice_no p {
	padding: 50px 0;
	text-align: center;
	font-size: 14px;
}
</style>
